import type { ICourse, ICourseEntity } from "~~/shared/types/course";

export const DEFAULT_LESSON_TITLE = "Без названия";
export const MIN_PUBLISHABLE_LESSON_TITLE_LENGTH = 4;

export const canPublishLesson = (
  entity: Pick<ICourseEntity, "title"> | null | undefined,
) => {
  const title = entity?.title?.trim();
  if (!title) return false;
  if (title === DEFAULT_LESSON_TITLE) return false;
  return title.length >= MIN_PUBLISHABLE_LESSON_TITLE_LENGTH;
};

/** A course counts as completed when every entity has been finished. */
export const isCourseCompleted = (
  course: Pick<ICourse, "totalEntities" | "completedEntities">,
) => {
  const total = Number(course.totalEntities ?? 0);
  return total > 0 && Number(course.completedEntities ?? 0) >= total;
};

/** In progress: at least one entity done but not all. */
export const isCourseStarted = (
  course: Pick<ICourse, "totalEntities" | "completedEntities">,
) => {
  const total = Number(course.totalEntities ?? 0);
  const done = Number(course.completedEntities ?? 0);
  return done > 0 && done < total;
};
